import { Icon } from "./Icon"

export function DeliveryContact({ id, postcode, productName, quantity, whatsapp }: {
    id: string; postcode: string; productName: string; quantity: number; whatsapp?: string
}) {
    const message = `Hi, I'd like to hire ${quantity} × ${productName}. Could you please check delivery availability for ${postcode}?`
    const email = `mailto:contact@arctic-hire.co.uk?subject=${encodeURIComponent(`Dehumidifier hire enquiry — ${postcode}`)}&body=${encodeURIComponent(message)}`
    const number = (whatsapp?.trim() || "+44 20 3411 1468").replace(/\D/g, "")
    return <section id={id} className="ah-delivery-contact" aria-labelledby={`${id}-title`}>
        <div className="ah-delivery-contact-icon" aria-hidden="true"><Icon name="truck" /></div>
        <div role="status" aria-live="polite">
            <h3 id={`${id}-title`}>Please get in touch to order</h3>
            <p>We have limited delivery availability for <strong>{postcode}</strong>. Please contact us with your order requirements and we'll get back to you as soon as possible.</p>
        </div>
        <div className="ah-delivery-contact-actions">
            <a className="ah-primary-button" href={`https://wa.me/${number}?text=${encodeURIComponent(message)}`} target="_blank" rel="noopener noreferrer"><Icon name="whatsapp" />WhatsApp us</a>
            <a className="ah-secondary-button" href={email}><Icon name="email" />Email us</a>
        </div>
    </section>
}
